module.exports = __webpack_public_path__ + "static/media/card-image-two.50fd31a6.png";